import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProcessingService } from '../services/processing.service';

@Injectable()
export class ProcessingInterceptor implements HttpInterceptor {
  constructor(private processingService: ProcessingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Optionally skip some URLs (polling / health checks) by checking req.url
    // if (req.url.includes('/health')) return next.handle(req);

    this.processingService.start();
    return next.handle(req).pipe(
      finalize(() => this.processingService.stop())
    );
  }
}
